import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Config from '../../commons/config/Config.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';

const MENSAJES = {
    aceptar: {
        ok:    { titulo: '¡Suscripción confirmada!', texto: 'A partir de ahora recibirás las notificaciones por mail.' },
        error: { titulo: 'No se pudo confirmar',    texto: 'El enlace es inválido o ya fue utilizado.'              },
    },
    baja: {
        ok:    { titulo: '¡Suscripción cancelada!', texto: 'Ya no recibirás notificaciones por mail.'                },
        error: { titulo: 'No se pudo procesar',     texto: 'El enlace es inválido o ya fue utilizado.'              },
    },
};

class SuscripcionMail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            estado:     'cargando',   // 'cargando' | 'ok' | 'error'
            countdown:  3,
            redirectTo: null,
        };
        this.redirectTimer = null;
        this.loginRandom   = 1 + Math.floor((4 - 1) * Math.random());
    }

    getBrandedLogo(defaultFilename, visibilityConfigKey = null) {
        if (visibilityConfigKey && ConfigBusiness.get(visibilityConfigKey) === 'false') return null;
        const slug = ConfigBusiness.get('generales.clienteSlug');
        if (slug && slug !== 'false' && slug !== 'default')
            return `${process.env.PUBLIC_URL}/images/branding/${slug}/${defaultFilename}`;
        return `${process.env.PUBLIC_URL}/images/company/${defaultFilename}`;
    }

    componentDidMount() {
        document.body.className = 'vertical-layout vertical-menu 1-column menu-expanded blank-page blank-page';
        document.body.setAttribute('data-col', '1-column');

        const params   = new URLSearchParams(this.props.location.search);
        const token    = params.get('token') || '';
        const email    = params.get('email') || '';
        const accion   = this.props.accion;
        const endpoint = Config.get('apiUrlBase') + '/public/suscripcion-mail/' + accion
                         + '?token=' + encodeURIComponent(token)
                         + '&email=' + encodeURIComponent(email);

        fetch(endpoint, { method: 'GET', headers: { 'Accept': 'application/json' } })
            .then(response => {
                this.setState({ estado: response.ok ? 'ok' : 'error' }, () => this.startCountdown());
            })
            .catch(() => {
                this.setState({ estado: 'error' }, () => this.startCountdown());
            });
    }

    componentWillUnmount() {
        if (this.redirectTimer) clearInterval(this.redirectTimer);
    }

    startCountdown() {
        this.redirectTimer = setInterval(() => {
            this.setState(prevState => {
                if (prevState.countdown <= 1) {
                    clearInterval(this.redirectTimer);
                    return { countdown: 0, redirectTo: '/' };
                }
                return { countdown: prevState.countdown - 1 };
            });
        }, 1000);
    }

    render() {
        if (this.state.redirectTo) return <Redirect push to={this.state.redirectTo} />;

        const accion    = this.props.accion;
        const estado    = this.state.estado;
        const msg       = estado !== 'cargando' ? MENSAJES[accion][estado] : null;
        const esOk      = estado === 'ok';

        const logoAppSrc       = this.getBrandedLogo('logo-login-app.png');
        const logoCompanySrc   = this.getBrandedLogo('logo-login-company.png', 'frontend.logos.company.visible');
        const logoPoweredBySrc = this.getBrandedLogo('logo-login-powered-by.png', 'frontend.logos.poweredBy.visible');

        return (
            <div className="app-content content">
                <div className="content-wrapper">
                    <div className="content-body">
                        <video
                            className="video-login-bg"
                            autoPlay muted loop
                            poster={`${process.env.PUBLIC_URL}/images/images-login/image${this.loginRandom}.png`}
                        >
                            <source src={`${process.env.PUBLIC_URL}/images/videos-login/video${this.loginRandom}.mp4`} type="video/mp4" />
                        </video>

                        <section className="flexbox-container">
                            <div className="col-12 d-flex align-items-center justify-content-center">
                                <div className="col-11 col-sm-8 col-md-6 col-lg-4 p-0" style={{ maxWidth: '400px' }}>
                                    <div className="card border-0 m-0" style={{ borderRadius: '1rem', boxShadow: '0 15px 35px rgba(0,0,0,0.2)' }}>

                                        <div className="card-header border-0 text-center pb-0" style={{ paddingTop: '2rem' }}>
                                            <img
                                                src={logoAppSrc}
                                                alt="App Logo"
                                                className="img-fluid center-block"
                                                style={{ maxHeight: '90px', objectFit: 'contain' }}
                                                onError={(e) => { e.target.onerror = null; e.target.src = '/images/company/logo-login-app.png'; }}
                                            />
                                        </div>

                                        <div className="card-body" style={{ padding: '1.5rem 1.5rem 1rem' }}>
                                            {estado === 'cargando' ? (
                                                <div className="text-center py-3">
                                                    <i className="la la-spinner spinner" style={{ fontSize: '50px', color: '#0abfbc' }}></i>
                                                </div>
                                            ) : (
                                                <div className="text-center py-2">
                                                    <i
                                                        className={esOk ? 'la la-check-circle' : 'la la-frown-o'}
                                                        style={{ fontSize: '70px', color: esOk ? '#0abfbc' : '#d9534f' }}
                                                    ></i>
                                                    <h5 className={`font-weight-bold mt-2 ${esOk ? 'text-success' : 'text-danger'}`}>
                                                        {msg.titulo}
                                                    </h5>
                                                    <p className="text-muted mb-3" style={{ fontSize: '13px' }}>
                                                        {msg.texto}
                                                    </p>
                                                    <div className="alert alert-secondary p-2 mb-0" style={{ borderRadius: '8px', fontSize: '12px' }}>
                                                        Redirigiendo en <strong>{this.state.countdown}</strong> {this.state.countdown === 1 ? 'segundo' : 'segundos'}...
                                                    </div>
                                                </div>
                                            )}

                                            <div className="mt-3 pt-3" style={{ borderTop: '1px solid #f3f3f3' }}>
                                                <div className="row align-items-center">
                                                    <div className="col-6 text-left">
                                                        {logoCompanySrc && (
                                                            <img src={logoCompanySrc} alt="Company" className="img-fluid" style={{ maxHeight: '35px', maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.onerror = null; e.target.src = '/images/company/logo-login-company.png'; }} />
                                                        )}
                                                    </div>
                                                    <div className="col-6 text-right">
                                                        {logoPoweredBySrc && (
                                                            <img src={logoPoweredBySrc} alt="Powered By" className="img-fluid" style={{ maxHeight: '30px', maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.onerror = null; e.target.src = '/images/company/logo-login-powered-by.png'; }} />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        );
    }
}

export default SuscripcionMail;
